import React from 'react'
import './Bono.css';

function Bonos(bono) {
    const factor = Number(bono?.value || 1);
    const value = [2, 3, 5, 10].includes(factor) ? `X${factor}` : '';
  
    return (
        <div className="flotante_bono">
            <div className="flot1"></div>
            <div className="fila"><div className="corrien_dogs"><p className="corri">Corrien</p><p className="can">DOGS</p></div></div>
            <div className="flot1"></div>

            <div className="flot1"></div>
            <div className="fila1"><p className="bonusflot bonflo"><b>BONO</b></p></div>
            <div className="flot1"></div>

            <div className="flot1"></div>
            <div className="fila2"><p className="bonusflot equflo"><b>{value}</b></p></div>
            <div className="flot1"></div>

            <div className="flot1"></div>
            <div className="flot1"></div>
            <div className="flot1"></div>
        </div>
    )
}

export default Bonos
